document.addEventListener("DOMContentLoaded", () => {
const apiKey = "AIzaSyBqFIj-tkIjXajqvaBybk9sUJ1Eegcvhck";
loadGoogleMaps(apiKey)

    .then(() => {

        initMap();

        moveCheckoutButton();

        loadSavedLocation();

    })

    .catch(console.error);
    const checkoutButton = document.getElementById("checkout");

    if (checkoutButton) {

        checkoutButton.disabled = true;
        checkoutButton.textContent = "Verify Delivery Location";

    }

});

let map;
let marker;
let autocomplete;
let geocoder;

function loadGoogleMaps(apiKey) {

    return new Promise((resolve, reject) => {

        if (window.google && window.google.maps) {
            resolve();
            return;
        }

        const script = document.createElement("script");

        script.src =
            `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;

        script.async = true;
        script.defer = true;

        script.onload = resolve;
        script.onerror = reject;

        document.head.appendChild(script);

    });

}

let deliveryVerified = false;
let deliveryLocation = {

    city: "",

    state: "",

    pincode: "",

    placeId: "",

    address: ""

};

const SERVICEABLE_PINCODES =
    window.RootslaneConfig?.serviceablePincodes || [];

function initMap() {

    const mapElement = document.getElementById("rl-google-map");

    const input = document.getElementById("rl-location-search");

 

    map = new google.maps.Map(mapElement, {

        center: {

            lat: 28.4595,
            lng: 77.0266

        },

        zoom: 12,

        mapTypeControl: false,

        streetViewControl: false,

        fullscreenControl: false

    });

    geocoder = new google.maps.Geocoder();

   marker = new google.maps.Marker({

    map: map,

    visible: false,

    draggable: true

});


    autocomplete = new google.maps.places.Autocomplete(input, {

        componentRestrictions: {
            country: "in"
        },

        fields: [
            "geometry",
            "formatted_address",
            "place_id",
            "name",
             "address_components"
        ]

    });

   // 👇 Add these listeners here
    autocomplete.addListener(
        "place_changed",
        onPlaceChanged
    );
    marker.addListener(
    "dragend",
    onMarkerDragged
);

    /*
===========================================================
RESET WHEN SEARCH IS CLEARED
===========================================================
*/

input.addEventListener("input", function () {

    if (this.value.trim() !== "") return;

    // Hide map
    document.getElementById("rl-google-map").style.display = "none";

    // Clear serviceability message
    const message = document.getElementById("rl-serviceability-message");

 if (message) {

    // Reset verification state
    deliveryVerified = false;

    message.className = "rl-serviceability-message";
    message.innerHTML = "";

    const checkoutButton = document.getElementById("checkout");

    if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.textContent = "Verify Delivery Location";
    }

}

    // Clear hidden fields
    document.getElementById("rl-latitude").value = "";
    document.getElementById("rl-longitude").value = "";
    document.getElementById("rl-place-id").value = "";
    document.getElementById("rl-formatted-address").value = "";

});



const currentLocationBtn =
    document.getElementById("rl-current-location");

if (currentLocationBtn) {

    currentLocationBtn.addEventListener("click", useCurrentLocation);

}

}
function handleUnresolvedPincode() {

    console.warn(
        "Unable to determine PIN code for selected location."
    );

    const checkoutButton =
        document.getElementById("checkout");

    if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.textContent =
            "Unable to verify location";
    }

    updateServiceabilityUI(false, "");

}


function getPincodeFromGoogle(place) {

    return new Promise((resolve) => {

        // First try the selected Place's address components
        if (place.address_components) {

            for (const component of place.address_components) {

                if (component.types.includes("postal_code")) {
                    resolve(component.long_name);
                    return;
                }

            }

        }

        // If Google Places did not provide a PIN,
        // reverse geocode the coordinates
        if (!place.geometry || !geocoder) {
            resolve("");
            return;
        }

        geocoder.geocode(
            {
                location: place.geometry.location
            },
            (results, status) => {

                if (status !== "OK" || !results.length) {
                    resolve("");
                    return;
                }

                // Search ALL Google results for postal_code
                for (const result of results) {

                    if (!result.address_components) continue;

                    for (const component of result.address_components) {

                        if (component.types.includes("postal_code")) {

                            resolve(component.long_name);
                            return;

                        }

                    }

                }

                // Google still did not return a PIN
                resolve("");

            }
        );

    });

}
async function updateSelectedLocation(place) {

    if (!place.geometry) return;

    /*
    ===========================================================
    EXTRACT ADDRESS DETAILS
    ===========================================================
    */

    let pincode = "";
    let city = "";
    let state = "";

    if (place.address_components) {

        place.address_components.forEach(component => {

            if (component.types.includes("postal_code")) {
                pincode = component.long_name;
            }

            if (component.types.includes("locality")) {
                city = component.long_name;
            }

            if (component.types.includes("administrative_area_level_1")) {
                state = component.long_name;
            }

        });

    }

    /*
    ===========================================================
    FALLBACK: GET PIN FROM GOOGLE REVERSE GEOCODING
    ===========================================================
    */

    if (!pincode) {

        console.log(
            "PIN not available from Place result. Trying reverse geocoding..."
        );

        pincode = await getPincodeFromGoogle(place);

    }

    console.log("Resolved PIN:", pincode);

    /*
    ===========================================================
    CHECK SERVICEABILITY
    ===========================================================
    */

   let serviceable = false;

if (pincode) {

    serviceable =
        isServiceablePincode(pincode);

    updateServiceabilityUI(
        serviceable,
        pincode
    );

} else {

    handleUnresolvedPincode();

}
    /*
    ===========================================================
    SAVE DELIVERY LOCATION
    ===========================================================
    */

    deliveryLocation = {

        city,

        state,

        pincode,

        placeId: place.place_id || "",

        address: place.formatted_address || ""

    };

    const location =
        place.geometry.location;

    map.panTo(location);

    map.setZoom(17);

    marker.setVisible(true);

    marker.setPosition(location);

    document.getElementById(
        "rl-google-map"
    ).style.display = "block";

    document.getElementById(
        "rl-latitude"
    ).value = location.lat();

    document.getElementById(
        "rl-longitude"
    ).value = location.lng();

    document.getElementById(
        "rl-place-id"
    ).value =
        place.place_id || "";

    document.getElementById(
        "rl-formatted-address"
    ).value =
        place.formatted_address || "";

    /*
    ===========================================================
    SAVE TO SHOPIFY CART
    ===========================================================
    */

    saveLocationToCart({

        latitude: location.lat(),

        longitude: location.lng(),

        placeId: place.place_id,

        address: place.formatted_address,

        city,

        state,

        pincode,

        serviceable

    });

    /*
    ===========================================================
    CHECKOUT BUTTON
    ===========================================================
    */

    const checkoutButton =
        document.getElementById("checkout");

    if (checkoutButton) {

        if (serviceable) {

            checkoutButton.disabled = false;

            checkoutButton.textContent =
                "Proceed to Checkout";

        } else {

            checkoutButton.disabled = true;

            checkoutButton.textContent =
                "Non-serviceable Area";

        }

    }

}
function onPlaceChanged() {

    const place = autocomplete.getPlace();

    updateSelectedLocation(place);

}
    
/*
===========================================================
CHECK SERVICEABILITY
===========================================================
*/

function getWeekendCityForPincode(pincode) {

    const weekendCities =
        window.RootslaneConfig?.weekendCities || {};

    for (const [cityKey, pincodes] of Object.entries(weekendCities)) {

        if (Array.isArray(pincodes) && pincodes.includes(pincode)) {
            return cityKey;
        }

    }

    return null;

}

function getTodaySchedule() {

    const schedule =
        window.RootslaneConfig?.weekendSchedule || {};

    const dayNames = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
    ];

    const today = dayNames[new Date().getDay()];

    return {
        dayName: today,
        config: schedule[today] || null
    };

}

function isWithinSchedule(scheduleConfig) {

    if (!scheduleConfig || scheduleConfig.enabled !== true) {
        return false;
    }

    const now = new Date();

    const currentMinutes =
        now.getHours() * 60 + now.getMinutes();

    const startMinutes =
        Number(scheduleConfig.startHour || 0) * 60 +
        Number(scheduleConfig.startMinute || 0);

    const endMinutes =
        Number(scheduleConfig.endHour ?? 23) * 60 +
        Number(scheduleConfig.endMinute ?? 59);

    return currentMinutes >= startMinutes &&
           currentMinutes <= endMinutes;

}

function getWeekendServiceability(pincode) {

    const cityKey = getWeekendCityForPincode(pincode);

    if (!cityKey) {
        return {
            serviceable: false,
            weekend: false,
            cityKey: null,
            schedule: null
        };
    }

    const today = getTodaySchedule();
    const schedule = today.config;

    const cityIsEnabledToday =
        Array.isArray(schedule?.cities) &&
        schedule.cities.includes(cityKey);

    const timeIsValid =
        isWithinSchedule(schedule);

    return {
        serviceable: cityIsEnabledToday && timeIsValid,
        weekend: true,
        cityKey,
        schedule
    };

}

function getWeekendCityDisplayName(cityKey) {

    const cityNames = {
        northDelhi: "North Delhi",
        westDelhi: "West Delhi",
        eastDelhi: "East Delhi",
        noida: "Noida",
        ghaziabad: "Ghaziabad"
    };

    if (cityNames[cityKey]) {
        return cityNames[cityKey];
    }

    // Fallback: convert config key into a readable city name.
    return String(cityKey || "this location")
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());

}

function formatWeekendTime(scheduleConfig) {

    if (!scheduleConfig) return "";

    const endHour = Number(scheduleConfig.endHour ?? 23);
    const endMinute = Number(scheduleConfig.endMinute ?? 59);

    // For a daytime cutoff such as 12:00 noon, show only the cutoff.
    if (endHour < 23 || endMinute < 59) {
        if (endHour === 12 && endMinute === 0) {
            return "until 12 noon";
        }

        const suffix = endHour >= 12 ? "PM" : "AM";
        const displayHour = endHour % 12 || 12;
        const displayMinute = String(endMinute).padStart(2, "0");

        return `until ${displayHour}:${displayMinute} ${suffix}`;
    }

    return "";

}

function getWeekendMessagesForCity(cityKey) {

    const schedule =
        window.RootslaneConfig?.weekendSchedule || {};

    const dayOrder = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday"
    ];

    const dayLabels = {
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday"
    };

    const availableDays = [];

    dayOrder.forEach(day => {

        const dayConfig = schedule[day];

        if (
            dayConfig?.enabled === true &&
            Array.isArray(dayConfig.cities) &&
            dayConfig.cities.includes(cityKey)
        ) {
            availableDays.push({
                day,
                label: dayLabels[day],
                cutoff: formatWeekendTime(dayConfig)
            });
        }

    });

    if (!availableDays.length) {
        return [];
    }

    const cityName = getWeekendCityDisplayName(cityKey);

    const fullDayNames = availableDays
        .filter(item => !item.cutoff)
        .map(item => item.label);

    const cutoffDays = availableDays
        .filter(item => item.cutoff);

    const parts = [];

    if (fullDayNames.length) {
        const dayText = fullDayNames.length === 1
            ? fullDayNames[0]
            : fullDayNames.slice(0, -1).join(", ") + " & " + fullDayNames.at(-1);

        parts.push(`${dayText}`);
    }

    cutoffDays.forEach(item => {
        parts.push(`${item.label} ${item.cutoff}`);
    });

    let availabilityText = "";

    if (parts.length === 1) {
        availabilityText = parts[0];
    } else if (parts.length === 2) {
        availabilityText = `${parts[0]} and ${parts[1]}`;
    } else {
        availabilityText = parts.slice(0, -1).join(", ") + ", and " + parts.at(-1);
    }

    return [
        `Weekend delivery only — ${cityName} orders are accepted on ${availabilityText}.`
    ];

}

function isServiceablePincode(pincode) {

    // Normal serviceable pincodes are always active.
    if (SERVICEABLE_PINCODES.includes(pincode)) {
        return true;
    }

    // Weekend-only pincodes are active only when their
    // city is enabled for the current day and time.
    return getWeekendServiceability(pincode).serviceable;

}

/*
===========================================================
UPDATE SERVICEABILITY UI
===========================================================
*/

function updateServiceabilityUI(serviceable, pincode) {

    const message =
        document.getElementById("rl-serviceability-message");

    const checkoutButton =
        document.getElementById("checkout");

    if (!message) return;

    const weekendInfo =
        pincode ? getWeekendServiceability(pincode) : null;

    /*
    =======================================================
    NORMAL SERVICEABLE PINCODE
    =======================================================
    */

    if (serviceable && !weekendInfo?.weekend) {

        deliveryVerified = true;

        message.className =
            "rl-serviceability-message rl-serviceability-success";

        message.innerHTML =
            `✅ Great! We deliver to <strong>${pincode}</strong>.`;

        if (checkoutButton) {
            checkoutButton.disabled = false;
            checkoutButton.textContent = "Proceed to Checkout";
        }

        return;

    }

    /*
    =======================================================
    WEEKEND-ONLY PINCODE
    =======================================================
    */

    if (weekendInfo?.weekend) {

        if (serviceable) {

            deliveryVerified = true;

            message.className =
                "rl-serviceability-message rl-serviceability-success";

            const availableMessages =
                getWeekendMessagesForCity(weekendInfo.cityKey);

            const configuredMessage =
                availableMessages[0] ||
                "Weekend delivery is available for this location.";

            message.innerHTML =
                `✅ ${configuredMessage}`;

            if (checkoutButton) {
                checkoutButton.disabled = false;
                checkoutButton.textContent = "Proceed to Checkout";
            }

        } else {

            deliveryVerified = false;

            message.className =
                "rl-serviceability-message rl-serviceability-error";

            const availableMessages =
                getWeekendMessagesForCity(weekendInfo.cityKey);

            if (availableMessages.length) {

                message.innerHTML =
                    `📦 ${availableMessages[0]}`;

            } else {

                message.innerHTML =
                    "📦 Weekend delivery is currently not available for this location.";

            }

            if (checkoutButton) {
                checkoutButton.disabled = true;
                checkoutButton.textContent = "Weekend Delivery Only";
            }

        }

        return;

    }

    /*
    =======================================================
    OTHER NON-SERVICEABLE PINCODE
    =======================================================
    */

    deliveryVerified = false;

    message.className =
        "rl-serviceability-message rl-serviceability-error";

    message.innerHTML =
        `❌ Sorry, this is a <strong>non-servicible pincode.</strong>`;

    if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.textContent = "Non-serviceable Area";
    }

}

/*
===========================================================
MOVE SHOPIFY CHECKOUT BUTTON
===========================================================
*/

  function moveCheckoutButton() {

        const checkoutContainer = document.getElementById("rl-checkout-container");

        const checkoutSection = document.querySelector(".cart__ctas");

        if (!checkoutContainer || !checkoutSection) return;

        // Already moved
        if (checkoutContainer.contains(checkoutSection)) return;

        checkoutContainer.appendChild(checkoutSection);

    }

  


  

/*
===========================================================
VALIDATE BEFORE CHECKOUT
===========================================================
*/

document.addEventListener("click", function (event) {

    const checkoutButton = event.target.closest("#checkout");

    if (!checkoutButton) return;

    const formattedAddress = document.getElementById("rl-formatted-address").value;
    const serviceableMessage = document.getElementById("rl-serviceability-message");

    // No address selected
    if (!formattedAddress) {

        event.preventDefault();
        event.stopPropagation();

        serviceableMessage.className =
            "rl-serviceability-message rl-serviceability-error";

        serviceableMessage.innerHTML =
            "❌ Please verify your delivery location before proceeding.";

        return;
    }

    // Re-check serviceability at the exact moment of checkout.
    // This prevents a weekend PIN from remaining enabled after
    // its configured day/time window has ended.
    const currentPincode = deliveryLocation.pincode || "";
    const currentServiceable =
        currentPincode ? isServiceablePincode(currentPincode) : false;

    if (currentServiceable !== deliveryVerified) {

        updateServiceabilityUI(
            currentServiceable,
            currentPincode
        );

    }

    // Non-serviceable area
    if (!currentServiceable) {

        event.preventDefault();
        event.stopPropagation();

        return;

    }

});

/*
===========================================================
SAVE LOCATION TO SHOPIFY CART
===========================================================
*/

function saveLocationToCart(locationData) {

    fetch("/cart/update.js", {

        method: "POST",

        headers: {
            "Content-Type": "application/json"
        },

        body: JSON.stringify({

            attributes: {

                "Delivery Latitude": String(locationData.latitude),
                "Delivery Longitude": String(locationData.longitude),

                "Google Place ID": locationData.placeId || "",
                "Formatted Address": locationData.address || "",

                "Delivery City": locationData.city || "",
                "Delivery State": locationData.state || "",
                "Delivery Pincode": locationData.pincode || "",

                "Delivery Serviceable":
                    locationData.serviceable ? "Yes" : "No"

            }

        })

    })

    .then(res => res.json())

    .then(cart => {

        console.log(
            "Location saved",
            cart.attributes
        );

    })

    .catch(err => {

        console.error(
            "Failed to save location",
            err
        );

    });

}

/*
===========================================================
MARKER DRAGGED
===========================================================
*/

function onMarkerDragged() {

    const position = marker.getPosition();

    const latitude = position.lat();

    const longitude = position.lng();

    document.getElementById("rl-latitude").value = latitude;

    document.getElementById("rl-longitude").value = longitude;

  saveLocationToCart({

    latitude,

    longitude,

    placeId: deliveryLocation.placeId,

    address: deliveryLocation.address,

    city: deliveryLocation.city,

    state: deliveryLocation.state,

    pincode: deliveryLocation.pincode,

    serviceable: deliveryVerified

});

showPinUpdatedMessage();

    console.log(
        "Marker moved:",
        latitude,
        longitude
    );

}



/*
===========================================================
PIN UPDATE MESSAGE
===========================================================
*/

function showPinUpdatedMessage() {

    const message = document.getElementById("rl-pin-message");

    if (!message) return;

    message.innerHTML =
        "📍 Delivery pin updated successfully.";

    message.style.display = "block";

    clearTimeout(message.hideTimer);

    message.hideTimer = setTimeout(() => {

        message.style.display = "none";

    }, 3000);

}

/*
===========================================================
LOAD SAVED DELIVERY LOCATION
===========================================================
*/
function loadSavedLocation() {

    fetch("/cart.js")

        .then(res => res.json())

       .then(cart => {

    const attributes = cart.attributes || {};

    restoreSavedLocation(attributes);

})
     

        .catch(err => {

            console.error(
                "Failed to load saved location",
                err
            );

        });

}

/*
===========================================================
RESTORE SAVED DELIVERY LOCATION
===========================================================
*/

function restoreSavedLocation(attributes) {

    if (!attributes["Formatted Address"])
        return;

    const latitude =
        parseFloat(attributes["Delivery Latitude"]);

    const longitude =
        parseFloat(attributes["Delivery Longitude"]);

    if (isNaN(latitude) || isNaN(longitude))
        return;

    const location = {

        lat: latitude,

        lng: longitude

    };

    // Restore input

    document.getElementById("rl-location-search").value =
        attributes["Formatted Address"];

    document.getElementById("rl-formatted-address").value =
        attributes["Formatted Address"];

    document.getElementById("rl-place-id").value =
        attributes["Google Place ID"] || "";

    document.getElementById("rl-latitude").value =
        latitude;

    document.getElementById("rl-longitude").value =
        longitude;

    // Restore cached location

    deliveryLocation = {

        city:
            attributes["Delivery City"] || "",

        state:
            attributes["Delivery State"] || "",

        pincode:
            attributes["Delivery Pincode"] || "",

        placeId:
            attributes["Google Place ID"] || "",

        address:
            attributes["Formatted Address"] || ""

    };

    // Restore map

    map.panTo(location);

    map.setZoom(17);

    marker.setPosition(location);

    marker.setVisible(true);

    document.getElementById("rl-google-map").style.display =
        "block";

    // Recalculate serviceability using the CURRENT
    // configuration and current day/time.
    // Do not trust the previously saved "Yes" value,
    // because a weekend-only PIN may have expired.

    const serviceable =
        isServiceablePincode(deliveryLocation.pincode);

    updateServiceabilityUI(
        serviceable,
        deliveryLocation.pincode
    );

}

/*
===========================================================
USE CURRENT LOCATION
===========================================================
*/

function useCurrentLocation() {


    if (!navigator.geolocation) {

        alert("Geolocation is not supported.");

        return;

    }

    const button =
        document.getElementById("rl-current-location");

    button.disabled = true;

    button.innerHTML = "Getting location...";

    navigator.geolocation.getCurrentPosition(
        function(position){

            const lat = position.coords.latitude;

            const lng = position.coords.longitude;

            const location = {

                lat,

                lng

            };

            map.panTo(location);

            map.setZoom(17);

            marker.setPosition(location);

            marker.setVisible(true);

            document.getElementById(
                "rl-google-map"
            ).style.display = "block";

            geocoder.geocode(
                {
                    location
                },
                function(results,status){

                    button.disabled = false;

                    button.innerHTML =
                        "📍 Use My Current Location";

                    if(
                        status !== "OK" ||
                        !results.length
                    ){
                        return;
                    }

                    const place = results[0];
                    place.geometry = {
     location: marker.getPosition()
};

                    document.getElementById(
    "rl-location-search"
).value =
    place.formatted_address;

updateSelectedLocation(place);

                }

            );

        },
function(error){

    button.disabled = false;
    button.innerHTML = "📍 Use My Current Location";

    console.log(error);

    alert(
        "Error Code: " + error.code +
        "\nMessage: " + error.message
    );

},

        {

            enableHighAccuracy:false,

            timeout:30000,

            maximumAge: 300000 // 5 minutes

        }

    );

}

